import { render, staticRenderFns } from "./demoForm2.vue?vue&type=template&id=281e782a&"
import script from "./demoForm2.vue?vue&type=script&lang=js&"
export * from "./demoForm2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports